import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "@/services/i18n/client";
import { route, RouteKeys } from "@/services/routing/routes";
import { Button } from "@heycircle/ui/button";
import { LanguageSwitcher } from "@/components/navigation/language-switcher";
import { AppNavigation } from "@/components/navigation/app-navigation";
import { useAuth } from "@/lib/auth";
import { AppFooter } from "@/components/layout/AppFooter";

export default function PublicLayout() {
  const { t } = useTranslation("common");
  const { user, isLoaded } = useAuth();
  const isAuthenticated = isLoaded && user !== null;

  return (
    <>
      {isAuthenticated ? (
        <AppNavigation />
      ) : (
        <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="container flex h-14 items-center">
            <Link to={route(RouteKeys.HOME)} className="ml-6 mr-6 flex items-center">
              <img src="/logo/logo_black.svg" alt={t("appName")} className="h-8 w-auto" />
            </Link>
            <div className="flex-1"></div>
            <nav className="flex items-center gap-2 sm:gap-4">
              <Button variant="ghost" asChild>
                <Link to={route(RouteKeys.PRICING)}>Pricing</Link>
              </Button>
              <LanguageSwitcher />
              <Button variant="ghost" asChild>
                <Link to={route(RouteKeys.SIGN_IN)}>{t("nav.signIn")}</Link>
              </Button>
              <Button asChild>
                <Link to={route(RouteKeys.SIGN_UP)}>{t("nav.signUp")}</Link>
              </Button>
            </nav>
          </div>
        </header>
      )}
      <main>
        <Outlet />
      </main>
      <AppFooter />
    </>
  );
}
